import {
  EntityState,
  EntityAdapter,
  createEntityAdapter,
  Update,
} from '@ngrx/entity'
import { createReducer, on } from '@ngrx/store'
import { get } from 'lodash'

import { CollectionScreenState } from '@core/store'
import { SecurityPortfolio as SecurityPortfolioModel } from '@models/security-portfolio.model'
import * as fromParameters from './parameters-search-security-portfolio-menu.actions'
import * as fromStore from '@app/core/store'
import * as featureAdapter from '@core/store/feature-adapter'
/**
 * The basic State interface for the `search-security-portfolio-menu` component
 *
 */
export interface State
  extends EntityState<CollectionScreenState<SecurityPortfolioModel>> {}
/**
 * The basic NGRX reducer adapter for the `search-security-portfolio-menu` component
 *
 */
export const adapter: EntityAdapter<
  CollectionScreenState<SecurityPortfolioModel>
> = createEntityAdapter<CollectionScreenState<SecurityPortfolioModel>>({})
/**
 * The default state's properties for the `search-security-portfolio-menu` component
 *
 */
export const initialState: State = adapter.getInitialState()
/**
 * The basic reducer that manages the state of the `Search` component
 *
 * It is not recommended to modify this file.
 */
const _reducer = createReducer(
  initialState,
  on(fromParameters.initAction, (state, payload) =>
    adapter.addOne(payload, state)
  ),
  on(fromParameters.destroyAction, (state, payload) =>
    adapter.removeOne(payload.id, state)
  ),

  on(fromParameters.cancelAction, (state, payload) => {
    return adapter.updateOne(
      {
        id: payload.id,
        changes: { loading: true },
      },
      state
    )
  }),
  on(
    fromParameters.cancelFailAction,
    fromParameters.cancelSuccessAction,
    (state, payload) => {
      const changes = {
        loading: false,
      }
      return adapter.updateOne(
        {
          id: payload.id,
          changes: changes,
        },
        state
      )
    }
  ),
  on(fromParameters.selectAction, (state, payload) => {
    return adapter.updateOne(
      {
        id: payload.id,
        changes: { loading: true },
      },
      state
    )
  }),
  on(
    fromParameters.selectFailAction,
    fromParameters.selectSuccessAction,
    (state, payload) => {
      const changes = {
        loading: false,
      }
      return adapter.updateOne(
        {
          id: payload.id,
          changes: changes,
        },
        state
      )
    }
  ),

  on(fromParameters.rowsSelectionChangeAction, (state, payload) => {
    const changes = { rowsSelected: payload.rowsSelected }
    return adapter.updateOne(
      {
        id: payload.id,
        changes: changes,
      },
      state
    )
  }),
  on(fromParameters.countSuccessAction, (state, payload) => {
    const changes = {
      totalItems: payload['totalItems'],
    }
    return adapter.updateOne(
      {
        id: payload.id,
        changes: changes,
      },
      state
    )
  }),
  on(fromParameters.searchAction, (state, payload) => {
    return adapter.updateOne(
      {
        id: payload.id,
        changes: { loading: true },
      },
      state
    )
  }),
  on(fromParameters.searchSuccessAction, (state, payload) => {
    const changes = {
      value: payload.value,
      loading: false,
      rowId: null,
      vars: {
        size: payload.size,
        page: payload.page,
      },
    }
    return adapter.updateOne(
      {
        id: payload.id,
        changes: changes,
      },
      state
    )
  }),
  on(fromParameters.searchFailAction, (state, payload) => {
    const changes = {
      value: [],
      loading: false,
    }
    return adapter.updateOne(
      {
        id: payload.id,
        changes: changes,
      },
      state
    )
  })
)
/**
 * Exports the current reducer's function
 * @param state
 * @param action
 */
export function reducer(state, action) {
  return _reducer(state, action)
}
